import React from 'react'
import { Severity } from '@sentry/react'

import SentryErrorBoundary from '../Errors/SentryErrorBoundary'

import { NodeRenderer } from '@contentful/rich-text-react-renderer'

export type BlockOrInline = Parameters<NodeRenderer>[0]

interface Props {
  node: BlockOrInline
  children?: React.ReactNode
}

const RichTextErrorBoundary: React.FC<Props> = ({ node, children }) => {
  return (
    <SentryErrorBoundary
      beforeCapture={(scope) => {
        scope.addBreadcrumb({
          type: 'contentful-rich-text',
          level: Severity.Info,
          data: node,
        })
      }}
    >
      {children}
    </SentryErrorBoundary>
  )
}

export default RichTextErrorBoundary
